import { Avatar, Grid, IconButton, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Button from 'components/Common/Button';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';

interface ProfileContainerProp {
    name?: string;
    email?: string;
    imageUrl?: string;
    catholicDirectoryAccountNumber?: string;
    navigationHandle?: React.MouseEventHandler;
    showEditIcon?: boolean;
    isEmployee?: boolean;
    status?: string;
}

function ProfileContainer({
    name,
    email,
    navigationHandle,
    imageUrl,
    catholicDirectoryAccountNumber,
    showEditIcon,
    isEmployee,
    status,
}: ProfileContainerProp) {
    let navigate = useNavigate();
    return (
        <Grid container spacing={1} alignItems="center" sx={{ my: 3, flexWrap: 'nowrap' }}>
            {/* Left Section (Avatar) */}
            <Grid sx={{ mx: 2.5 }} item md={2}>
                <Avatar src={imageUrl} sx={{ width: 74, height: 74 }} />
            </Grid>

            {/* Middle Section (Text) */}
            <Grid item md={name ? 4 : 5}>
                {name ? (
                    <div>
                        <Typography sx={{ fontSize: 16, color: '#1F2937', fontWeight: 400 }} variant="h2">
                            {name}
                        </Typography>
                        <Typography sx={{ fontSize: 14, color: '#6B7280' }} variant="body2">
                            {email}
                        </Typography>
                        {isEmployee && (
                            <Typography sx={{ fontSize: 14, color: '#6B7280' }} variant="body2">
                                Status: {status}
                            </Typography>
                        )}
                    </div>
                ) : (
                    <div>
                        <Button
                            onClick={navigationHandle}
                            variant="outlined"
                            backgroundColor="none"
                            fontSize={14}
                            sx={{
                                mx: { md: 6 },
                            }}
                            title="Change Photo"
                        />
                    </div>
                )}
            </Grid>

            {/* Right Section (Catholic Directory and Edit Button) */}
            {showEditIcon && !isEmployee && (
                <Grid item sx={{ p: 0 }} md={name ? 5 : 5}>
                    <Typography sx={{ fontSize: 14, color: '#1F2937', fontWeight: 400 }} variant="h2">
                        Catholic Directory Account Number: <strong>{catholicDirectoryAccountNumber || ''}</strong>
                    </Typography>
                    {name && <div style={{ height: 20 }}></div>}
                </Grid>
            )}

            {showEditIcon && (
                <Grid sx={{ alignSelf: 'flex-start', marginTop: 1 }} item>
                    <IconButton onClick={() => navigate(routes.account.edit)} sx={{ color: 'black' }}>
                        <EditIcon />
                    </IconButton>
                </Grid>
            )}
        </Grid>
    );
}

export default ProfileContainer;
